import TextInput from '@oncolens/oncolens-ui/lib/components/FormControls/TextInput';
import clsx from 'clsx';
import FormField from '@oncolens/oncolens-ui/lib/libraries/FormField';
import useRequestFormStore from '../store';
import { StagingData, StagingStates, TemplateGridColumn } from './StagingTypes';

interface StagingTableProps {
	tableState: typeof StagingStates[number];
	data: StagingData[];
	columns: TemplateGridColumn[];
	formKey?: string;
}

function StagingTable({ tableState, data, columns, formKey }: StagingTableProps) {
  const getValues = useRequestFormStore((store) => store.getValues);
  return (
    <table data-cy="staging-table" className="table-auto">
      <thead>
        <tr>
          {columns?.map(
            (column) =>
              column.isVisible && (
                <th
                  key={column.id}
                  className={clsx(
                    'px-6 py-2 font-medium text-gray-900 bg-gray-200 border border-oncolensOrange-500 sm:px-4'
                  )}
                >
                  {column.label}
                </th>
              )
          )}
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={row.id}>
            {columns?.map(
              (column) =>
                column.isVisible && (
                  <td
                    key={`${column.id}-${row.id}`}
                    className={clsx(
                      'border border-oncolensOrange-500 -mt-px transition-all duration-500 ease-in-out',
                      (tableState === 'read' || (tableState === 'edit' && column.readOnly)) &&
												'px-4 py-2 text-gray-900',
                      tableState === 'edit' && !column.readOnly && 'p-1.5',
                      column.accessor === 'timing' && 'w-36',
                      index % 2 ? 'bg-gray-100' : 'bg-white'
                    )}
                  >
                    {tableState == 'edit' && !column.readOnly ? (
                      <FormField
                        name={`${formKey}.${row.id}.${column.accessor}`}
                        store={useRequestFormStore}
                        validationOptions={{
                          valueProvider: getValues
                        }}
                      >
                        {({ value, onChange }) => (
                          <TextInput
                            id={`${row.timing}-${column.accessor}`}
                            label={`${row.timing}-${column.accessor}`}
                            htmlName={`${row.timing}-${column.accessor}`}
                            type={'text'}
                            srLabel={true}
                            value={value}
                            onChange={onChange}
                          />
                        )}
                      </FormField>
                    ) : (
                      row[column.accessor]
                    )}
                  </td>
                )
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export { StagingTable as default };
